import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {} from 'services/mcatServices';
import { getMFSHLinkAPI, getMFSHStatusAPI, saveMFSHAnswersAPI } from 'services/mfshServices';
import { handleMessage } from 'shared/api/ErrorMessages';
import { saveMcatAnswers } from './mcatSlice';

interface Error {
  data: any;
}

export const saveMFSHAnswers = createAsyncThunk('SAVE_MFSH_ANSWERS', async (data: any, { rejectWithValue }) => {
  try {
    const response = await saveMFSHAnswersAPI(data);
    return response;
  } catch (err: any) {
    const e = err as Error;
    const status = e?.data?.errorCode;
    const message = handleMessage(status);
    const error = {
      err: err.data,
      message,
      show: false,
    };
    return rejectWithValue(error);
  }
});

export const getMFSHStatus = createAsyncThunk('GET_MFSH_STATUS', async (patientId: number, { rejectWithValue }) => {
  try {
    const response = await getMFSHStatusAPI(patientId);
    return response;
  } catch (err: any) {
    const e = err as Error;
    const status = e?.data?.errorCode;
    const message = handleMessage(status);
    const error = {
      err: err.data,
      message,
      show: false,
    };
    return rejectWithValue(error);
  }
});

export const getMFSHLink = createAsyncThunk('GET_JOTFORM_ID', async (patientId: number, { rejectWithValue }) => {
  try {
    const response = await getMFSHLinkAPI(patientId);
    return response;
  } catch (err: any) {
    const e = err as Error;
    const status = e?.data?.errorCode;
    const message = handleMessage(status);
    const error = {
      err: err.data,
      message,
      show: false,
    };
    return rejectWithValue(error);
  }
});

interface Loader {
  isQuestionFetched: boolean;
}

interface StateI {
  loaders: Loader;
  error: undefined;
}

const initialState = {
  loaders: {
    isQuestionFetched: false,
  },
  error: undefined,
};

const mcatQuestionSlice = createSlice({
  name: 'mcatQuestions',
  initialState,
  reducers: {
    clearError(state: StateI) {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(saveMcatAnswers.pending, (state: StateI) => {
      state.loaders.isQuestionFetched = true;
    });
    builder.addCase(saveMcatAnswers.fulfilled, (state: StateI) => {
      state.loaders.isQuestionFetched = false;
    });
    builder.addCase(saveMcatAnswers.rejected, (state: StateI) => {
      state.loaders.isQuestionFetched = false;
    });
  },
});

export default mcatQuestionSlice.reducer;
